import React, {Fragment} from 'react';

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell";

export default function AggregateCurrency(options, params, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const decimalPlaces = params ? params.decimalPlaces : 0
    const value = isValid ? gd.utils.roundToDecimals(props.value, decimalPlaces) : null;

    const currencyId = params ? params.symbol : null;
    let currencyMark = gd.const.currency[currencyId] ? gd.const.currency[currencyId].symbol : '';

    const normalized = typeof value === 'number' ? value : parseFloat(value);
    const valueLabel = normalized.toLocaleString('en', { useGrouping:true, minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:
            noDataLabel = '0';
            break;
        default:
            noDataLabel = gd.const.aggregate.label[props.aggregateFunction];
            break;
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={currencyMark + ' ' + valueLabel} {...props}>
            {isValid &&
            <Fragment>
                <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                <div className="aggregate-value aggregate-number">{currencyMark} {valueLabel}</div>
            </Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}